import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPropertyIdRelatedOptionsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePropertyRelatedOptionsQuery = (id: number, enabled = true) =>
	useQuery({
		queryKey: PortfolioKeys.propertyRelatedOptions(id),
		queryFn: processResponse(() => getPropertyIdRelatedOptionsV2(id)),
		enabled,
	});
